module.exports = __webpack_public_path__ + "static/media/setup-weather.c51d78aa.svg";